import React from 'react';
import { Field } from 'redux-form';
import { Form, Row, Col, Button } from 'antd';
import AntIcon from '../../shared/components/AntIcon';

import { renderInput } from '../../shared/utils/form_components';
import { required, url } from '../../shared/utils/form_validations';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 3 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 21 },
  },
};

const formItemLayoutWithoutLabel = {
  wrapperCol: {
    xs: { span: 24, offset: 0 },
    sm: { span: 21, offset: 3 },
  },
};

const BuyLinkFields = ({ fields, label }) => {
  return (
    <div>
      {fields.map((link, index, fields) => {
        return (
          <Form.Item
            {...(index === 0 ? formItemLayout : formItemLayoutWithoutLabel)}
            key={link}
            label={index === 0 ? label : null}
          >
            <Row gutter={8}>
              <Col span={6}>
                <Field
                  inputOnly
                  name={`${link}.title`}
                  placeholder="Title"
                  component={renderInput}
                  validate={fields.length > 1 ? required : null}
                  disabled={fields.length === 1}
                />
              </Col>
              <Col span={16}>
                <Field
                  inputOnly
                  name={`${link}.url`}
                  placeholder="Url"
                  component={renderInput}
                  validate={[required, url]}
                />
              </Col>
              <Col className="is-right">
                {index > 0 &&
                  <AntIcon
                    type="arrow-up"
                    style={{ cursor: 'pointer' }}
                    onClick={() => fields.swap(index, index - 1)}
                  />
                }
                {index < fields.length - 1 &&
                  <AntIcon
                    type="arrow-down"
                    style={{ cursor: 'pointer' }}
                    onClick={() => fields.swap(index, index + 1)}
                  />
                }
                &nbsp;&nbsp;
                <AntIcon
                  type="minus-circle-o"
                  onClick={() => fields.remove(index)}
                  style={{ cursor: 'pointer', color: 'red' }}
                />
              </Col>
            </Row>
          </Form.Item>
      )})}

      <Form.Item
        {...(fields.length === 0 ? formItemLayout : formItemLayoutWithoutLabel)}
        label={fields.length === 0 ? label : null}
      >
        <Button type="dashed" onClick={() => fields.push({})}>
          <AntIcon type="plus" />Add Buy Link
        </Button>
      </Form.Item>
    </div>
  );
}

export default BuyLinkFields;
